const ABTestMetric = Object.freeze({
  "Unique Clicks": 0,
  "Unique Opens": 1,
});

const ABTestPublishedStatus = Object.freeze({
  Unpublished: 1,
  Published: 4,
});

const ABTestWinnerType = Object.freeze({
  Automatic: 0,
  Manual: 1,
});

const AdvancedSearchGroupType = Object.freeze({
  And: "And",
  Or: "Or",
});

const AdvancedSearchNewOptionType = Object.freeze({
  Columns: "Columns",
  Filters: "Filters",
});

const AdvancedSearchNodeType = Object.freeze({
  Filter: "Filter",
  Group: "Group",
});

const AdvancedSearchType = Object.freeze({
  Contacts: "contact",
  "Contact Audits": "g4gdpr_contactaudit",
  "Communication Audits": "g4c_communicationaudit",
});

const AdvancedSearchTypeForMarketingAdministrator = Object.freeze({
  Contacts: AdvancedSearchType.Contacts,
  "Contact Audits": AdvancedSearchType["Contact Audits"],
  "Communication Audits": AdvancedSearchType["Communication Audits"],
});

const AlertStyle = Object.freeze({
  Primary: "alert-primary",
  Secondary: "alert-secondary",
  Success: "alert-success",
  Danger: "alert-danger",
  Warning: "alert-warning",
  Info: "alert-info",
  Light: "alert-light",
  Dark: "alert-dark",
});

const AutomationType = Object.freeze({
  Scheduled: 1,
  Triggered: 2,
});

const AutomationScheduleMode = Object.freeze({
  Daily: "Daily",
  Fixture: "Fixture",
});

const AutomationScheduleRelativeDirection = Object.freeze({
  Before: 1,
  After: 2,
  "Same Day": 3,
});

const AutomationStatus = Object.freeze({
  Unpublished: 0,
  Published: 1,
  Testing: 2,
});

const AutomationExecutionStatus = Object.freeze({
  Pending: 0,
  Claimed: 1,
  Queued: 2,
  Failed: 3,
  Completed: 4,
  Cancelled: 5,
  Expired: 6,
  Processing: 7,
});

const AutomationTriggerType = Object.freeze({
  "Abandoned Basket": "AbandonedBasket",
});

const AudienceType = Object.freeze({
  "A/B Testing": 32,
  Existing: 4,
  Automation: 16,
});

const AudienceTypeNoAB = Object.freeze({
  Existing: 4,
  Automation: 16,
});

const BackgroundStyle = Object.freeze({
  Primary: "bg-primary",
  Secondary: "bg-secondary",
  Success: "bg-success",
  Danger: "bg-danger",
  Warning: "bg-warning",
  Info: "bg-info",
  Light: "bg-light",
  Dark: "bg-dark",
});

const ButtonStyle = Object.freeze({
  Primary: "btn-primary",
  Secondary: "btn-secondary",
  Success: "btn-success",
  Danger: "btn-danger",
  Warning: "btn-warning",
  Info: "btn-info",
  OutlineInfo: "btn-outline-info",
  Light: "btn-light",
  Dark: "btn-dark",
  Link: "btn-link",
  OutlinePrimary: "btn-outline-primary",
  OutlineSecondary: "btn-outline-secondary",
  OutlineDanger: "btn-outline-danger",
  Close: "btn-close",
  // No btn-* variant, for a button styled entirely by its own classes.
  None: "",
});

const CommunicationActivityStatus = Object.freeze({
  Open: 0,
  Completed: 1,
  Cancelled: 2,
  Scheduled: 3,
});

const CommunicationAudienceType = Object.freeze({
  Marketing: 492740000,
  Transactional: 492740001,
});

const CommunicationPublishedStatus = Object.freeze({
  Unpublished: 1,
  Inactive: 2,
  Testing: 3,
  Published: 4,
});

const DataModelType = Object.freeze({
  Number: 1,
  Decimal: 2,
  Date: 3,
});

const DateTimePickerRangesAll = Object.freeze({
  Custom: 1,
  On: 2,
  "On or After": 3,
  "On or Before": 4,
  Yesterday: 5,
  Today: 6,
  Tomorrow: 7,
  "Next 7 Days": 8,
  "Last 7 Days": 9,
  "Next Month": 10,
  "Last Month": 11,
  "This Month": 12,
  "Next Year": 13,
  "Last Year": 14,
  "This Year": 15,
});

const DateTimePickerRangesFuture = Object.freeze({
  Custom: 1,
  On: 2,
  "On or After": 3,
  "On or Before": 4,
  Today: 6,
  Tomorrow: 7,
  "Next 7 Days": 8,
  "Next Month": 10,
  "This Month": 12,
  "Next Year": 13,
  "This Year": 15,
});

const DateTimePickerRangesPast = Object.freeze({
  Custom: 1,
  On: 2,
  "On or After": 3,
  "On or Before": 4,
  Yesterday: 5,
  Today: 6,
  "Last 7 Days": 9,
  "Last Month": 11,
  "This Month": 12,
  "Last Year": 14,
  "This Year": 15,
});

const DayOfWeek = Object.freeze({
  Sunday: 1,
  Monday: 2,
  Tuesday: 3,
  Wednesday: 4,
  Thursday: 5,
  Friday: 6,
  Saturday: 7,
});

const DefaultCommunicationMethods = Object.freeze({
  Port: 1,
  Folder: 2,
  "Web Service": 3,
});

const DynamicContentAttributeOperator = Object.freeze({
  "Equal To": "=",
  "Starts With": "StartsWith",
  "Ends With": "EndsWith",
  In: "In",
  "Not In": "NotIn",
  "Less Than": "<",
  "Greater Than": ">",
  "Less Than or Equal To": "<=",
  "Greater Than or Equal To": ">=",
  Between: "Between",
});

const EntityAuditType = Object.freeze({
  Create: 0,
  Update: 1,
  Delete: 2,
});

const FlowMode = Object.freeze({
  Test: 1,
  Live: 2,
});

const GDPRStatus = Object.freeze({
  Unknown: 0,
  "Opted In": 1,
  "Opted Out": 2,
});

const Gender = Object.freeze({
  Male: 1,
  Female: 2,
});

const GridBreakpoints = Object.freeze({
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
});

const InputType = Object.freeze({
  Button: "button",
  Checkbox: "checkbox",
  Radio: "radio",
  Submit: "submit",
  Text: "text",
});

const LoadingState = Object.freeze({
  NotLoaded: "NotLoaded",
  Loading: "Loading",
  Loaded: "Loaded",
});

const MarketingListType = Object.freeze({
  New: "new",
  Existing: "existing",
});

const Months = Object.freeze({
  January: 1,
  February: 2,
  March: 3,
  April: 4,
  May: 5,
  June: 6,
  July: 7,
  August: 8,
  September: 9,
  October: 10,
  November: 11,
  December: 12,
});

const OverviewColumn = Object.freeze({
  Main: 1,
  Side: 2,
  Full: 3,
});

const PreferredContactMethod = Object.freeze({
  Any: 1,
  Email: 2,
  Phone: 3,
  Mail: 5,
});

const RecordStatus = Object.freeze({
  Active: 0,
  Inactive: 1,
});

const Regarding = Object.freeze({
  Contact: 3, //"contact"
});

const RegardingContactOnly = Object.freeze({
  Contact: 3,
});

const RegardingForAccount = Object.freeze({
  Contact: 3, //"contact"
});

const RunAtType = Object.freeze({
  CRM: "crm",
  Warehouse: "warehouse",
});

const SelectedStartType = Object.freeze({
  Immediately: 0,
  Scheduled: 1,
});

const SidebarItemType = Object.freeze({
  Page: 1,
  Section: 2,
});

const StandardStatus = Object.freeze({
  Active: 0,
  Inactive: 1,
});

const SubscriptionGDPRStatus = Object.freeze({
  Subscribe: 0,
  Unsubscribe: 1,
});

const TargetedAtTypeNames = Object.freeze({
  Account: "account",
  Contact: "contact",
});

const TargetedAtType = Object.freeze({
  Account: 1,
  Contact: 2,
});

const ThreeCharacterMonths = Object.freeze({
  JAN: "JAN",
  FEB: "FEB",
  MAR: "MAR",
  APR: "APR",
  MAY: "MAY",
  JUN: "JUN",
  JUL: "JUL",
  AUG: "AUG",
  SEP: "SEP",
  OCT: "OCT",
  NOV: "NOV",
  DEC: "DEC",
});

const TimeInterval = Object.freeze({
  "1 minute": 1,
  "15 minutes": 15,
  "30 minutes": 30,
  "45 minutes": 45,
  "1 hour": 60,
  "1 hour 15 mins": 75,
  "1 hour 30 mins": 90,
  "1 hour 45 mins": 105,
  "2 hours": 120,
  "2 hours 30 mins": 150,
  "3 hours": 180,
  "3 hours 30 mins": 210,
  "4 hours": 240,
  "4 hours 30 mins": 270,
  "5 hours": 300,
  "5 hours 30 mins": 330,
  "6 hours": 360,
  "6 hours 30 mins": 390,
  "7 hours": 420,
  "7 hours 30 mins": 450,
  "8 hours": 480,
});

const YesNo = Object.freeze({
  No: 0,
  Yes: 1,
});

export {
  ABTestMetric,
  ABTestPublishedStatus,
  ABTestWinnerType,
  AdvancedSearchGroupType,
  AdvancedSearchNewOptionType,
  AdvancedSearchNodeType,
  AdvancedSearchType,
  AdvancedSearchTypeForMarketingAdministrator,
  AlertStyle,
  AutomationExecutionStatus,
  AutomationScheduleMode,
  AutomationScheduleRelativeDirection,
  AutomationStatus,
  AutomationTriggerType,
  AutomationType,
  AudienceType,
  AudienceTypeNoAB,
  BackgroundStyle,
  ButtonStyle,
  CommunicationActivityStatus,
  CommunicationAudienceType,
  CommunicationPublishedStatus,
  DataModelType,
  DateTimePickerRangesAll,
  DateTimePickerRangesFuture,
  DateTimePickerRangesPast,
  DayOfWeek,
  DefaultCommunicationMethods,
  DynamicContentAttributeOperator,
  EntityAuditType,
  FlowMode,
  GDPRStatus,
  Gender,
  GridBreakpoints,
  InputType,
  LoadingState,
  MarketingListType,
  Months,
  OverviewColumn,
  PreferredContactMethod,
  RecordStatus,
  Regarding,
  RegardingContactOnly,
  RegardingForAccount,
  RunAtType,
  SelectedStartType,
  SidebarItemType,
  StandardStatus,
  SubscriptionGDPRStatus,
  TargetedAtType,
  TargetedAtTypeNames,
  ThreeCharacterMonths,
  TimeInterval,
  YesNo,
};
